import React from 'react';
import { Sun, Moon, Coffee, Activity } from 'lucide-react';
export function Solution() {
  return <section className="py-16 md:py-24 bg-[#FAF8F5]" data-id="element-179">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <span className="text-[#C4705A] font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-182">
            El Método
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2D2A26] mb-6" data-id="element-183">
            La solución: Reset 7×3
          </h2>
          <p className="text-xl text-[#2D2A26]/70 max-w-2xl mx-auto" data-id="element-184">
            7 minutos, 3 momentos del día. Un sistema diseñado para interrumpir
            el ciclo de dolor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-185">
          {/* Card 1 */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-[#C4705A]/10 hover:shadow-md transition-shadow" data-id="element-186">
            <div className="w-12 h-12 bg-[#FFF4F0] rounded-full flex items-center justify-center mb-4 text-[#C4705A]" data-id="element-187">
              <Sun className="w-6 h-6" data-id="element-188" />
            </div>
            <h3 className="font-serif text-xl font-bold text-[#2D2A26] mb-2" data-id="element-189">
              1. Reset de Mañana
            </h3>
            <p className="text-[#2D2A26]/70 text-sm leading-relaxed" data-id="element-190">
              7 minutos para quitar rigidez antes de que el día te doble.
              Prepara tu cuerpo para el movimiento.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#C4705A] relative transform md:-translate-y-4" data-id="element-191">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C4705A] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-192">
              EL MÁS IMPORTANTE
            </div>
            <div className="w-12 h-12 bg-[#FFF4F0] rounded-full flex items-center justify-center mb-4 text-[#C4705A]" data-id="element-193">
              <Coffee className="w-6 h-6" data-id="element-194" />
            </div>
            <h3 className="font-serif text-xl font-bold text-[#2D2A26] mb-2" data-id="element-195">
              2. Reset de Pausa
            </h3>
            <p className="text-[#2D2A26]/70 text-sm leading-relaxed" data-id="element-196">
              7 minutos para cortar el pico de tensión a mitad del día. Evita
              que el dolor se acumule.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-[#C4705A]/10 hover:shadow-md transition-shadow" data-id="element-197">
            <div className="w-12 h-12 bg-[#FFF4F0] rounded-full flex items-center justify-center mb-4 text-[#C4705A]" data-id="element-198">
              <Moon className="w-6 h-6" data-id="element-199" />
            </div>
            <h3 className="font-serif text-xl font-bold text-[#2D2A26] mb-2" data-id="element-200">
              3. Reset de Noche
            </h3>
            <p className="text-[#2D2A26]/70 text-sm leading-relaxed" data-id="element-201">
              7 minutos para soltar y recuperarte. Mejora tu descanso y reduce
              la rigidez matutina.
            </p>
          </div>
        </div>

        <div className="bg-[#2D2A26] text-[#FAF8F5] p-8 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-202">
          <div className="flex items-start gap-4" data-id="element-203">
            <Activity className="w-8 h-8 text-[#C4705A] flex-shrink-0 mt-1" data-id="element-204" />
            <div data-id="element-205">
              <h3 className="font-serif text-xl font-bold mb-2" data-id="element-206">
                Incluye: Test de 60 Segundos
              </h3>
              <p className="text-[#FAF8F5]/80 text-sm max-w-md" data-id="element-207">
                No todas las espaldas duelen igual. Este test te ayuda a elegir
                la rutina exacta según tu zona de dolor (A, B o C).
              </p>
            </div>
          </div>
          <div className="flex-shrink-0" data-id="element-208">
            <span className="inline-block bg-[#C4705A] text-white text-sm font-bold px-4 py-2 rounded-lg" data-id="element-209">
              Personalizado
            </span>
          </div>
        </div>
      </div>
    </section>;
}